module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-big-orange-7d8e410ff3823d7117dba18a8815e8a6.svg";